import React from 'react';
import { FormInstance } from 'antd';
import { Card, Gutter, Text } from '@common/components';
import { SuppliersManagementNewSupplierForm } from '@institutions/components';

export type NewSupplierFormValues = {
  supplierName: string;
  mainContactEmail: string;
  invitationMessage?: string;
};

export function SuppliersManagementNewSupplierStepDetails({
  form,
  onFormFinish,
}: {
  onFormFinish: (values: NewSupplierFormValues) => void;
  form: FormInstance<NewSupplierFormValues>;
}) {
  return (
    <div
      className="suppliers-management-new-supplier-step-details"
      style={{ maxWidth: '700px' }}
    >
      <Card>
        <Gutter direction="bottom" size="lg">
          <Text>
            Fill to save the supplier&apos;s profile name and main contact
          </Text>
        </Gutter>
        <SuppliersManagementNewSupplierForm
          form={form}
          onFormFinish={onFormFinish}
        />
      </Card>
    </div>
  );
}
